import React, { useEffect, useMemo, useState } from "react";
import MasterDataFormV2 from "../../MasterDataFormV2";
import { useUser } from "contexts/v1/masterData/UserContext";
import { useShifts } from "../../master/context/ShiftsContext";
import { getRequest } from "services/api";

const schedulePatternOptions = [
  { value: "0068f131-b250-4cfd-96c9-20184090203f", label: "Default Pattern" }
];

const CreateSchedulePage = ({ initialData, onSuccess, onError, onDelete }) => {
  const { users } = useUser();
  const { shifts } = useShifts();
  const [holidayPackages, setHolidayPackages] = useState([]);

  useEffect(() => {
    let isMounted = true;
    getRequest("/ahr/holiday-packages?all=1")
      .then((response) => {
        if (!isMounted) return;
        setHolidayPackages(response?.data?.data || response?.data || []);
      })
      .catch(() => {
        if (isMounted) setHolidayPackages([]);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  // Transform initialData for edit mode
  const transformedInitialData = initialData
    ? {
        ...initialData,
        schedule_date: initialData.schedule_date
          ? (() => {
              const date = new Date(initialData.schedule_date);
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, "0");
              const day = String(date.getDate()).padStart(2, "0");
              return `${year}-${month}-${day}`;
            })()
          : "",
      }
    : null;

  // Create options from hooks data
  const userOptions = useMemo(() => users.data?.map(user => ({
    value: user.id,
    label: `${user.name} (${user.email})`
  })) || [], [users.data]);

  const shiftOptions = useMemo(() => shifts.data?.map(shift => ({
    value: shift.id,
    label: shift.name
  })) || [], [shifts.data]);

  const holidayPackageOptions = useMemo(() => holidayPackages.map((item) => ({
    value: item.id,
    label: `${item.name} (${item.quota || 0} hari)`,
  })), [holidayPackages]);

  const fields = useMemo(() => [
    {
      name: "user_id",
      label: "User",
      type: "select",
      required: true,
      options: userOptions,
      placeholder: "Select user",
    },
    {
      name: "shift_id",
      label: "Shift",
      type: "select",
      required: false,
      options: shiftOptions,
      placeholder: "Select shift",
    },
    {
      name: "schedule_date",
      label: "Schedule Date",
      type: "date",
      required: true,
      defaultValue: new Date().toISOString().split("T")[0], // Today's date
    },
    {
      name: "schedule_pattern_id",
      label: "Schedule Pattern",
      type: "select",
      required: false,
      options: schedulePatternOptions,
      placeholder: "Select schedule pattern",
    },
    {
      name: "is_day_off",
      label: "Day Off",
      type: "checkbox",
      required: false,
      defaultValue: false,
    },
    {
      name: "holiday_package_id",
      label: "Holiday Package (PH)",
      type: "select",
      required: false,
      options: holidayPackageOptions,
      placeholder: "Pilih package PH jika jadwal ini Public Holiday",
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      required: true,
      options: [
        { value: "draft", label: "Draft" },
        { value: "published", label: "Published" },
      ],
      defaultValue: "draft",
    },
  ], [userOptions, shiftOptions, holidayPackageOptions]);

  const handleTransformData = (data) => {
    const payload = { ...data };
    payload.is_public_holiday = payload.holiday_package_id ? 1 : 0;
    return payload;
  };

  return (
    <MasterDataFormV2
      apiUrl="/ahr/schedules"
      initialData={transformedInitialData}
      fields={fields}
      onSuccess={onSuccess}
      onError={onError}
      onDelete={onDelete}
      transformData={handleTransformData}
    />
  );
};

export default CreateSchedulePage;
